export function omit(obj, props) {
    const filteredEntries = Object.entries(obj).filter(([key]) => !props.includes(key));
    return Object.fromEntries(filteredEntries);
}
//# sourceMappingURL=omit.js.map